'use client'

import {
  ChangeEvent,
  ComponentProps,
  useEffect,
  useState,
  MouseEvent,
} from 'react'

import { Slot } from '@/shared/lib'

import { Input } from './input'
import { Icon } from '../icon'

type Props = Omit<ComponentProps<typeof Input>, 'onReset'> & {
  editable?: boolean
  onReset?: () => void
}

export const TextField = ({
  value: valueProp,
  onChange: onChangeProp,
  editable: editableProp,
  onReset,
  children,
  ...props
}: Props) => {
  const [value, setValue] = useState(valueProp ?? '')

  const editable = editableProp ?? !(props.readOnly || props.disabled)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
    onChangeProp?.(event)
  }

  const handleResetButtonClick = (event: MouseEvent) => {
    event.stopPropagation()

    setValue('')
    onReset?.()
  }

  useEffect(() => {
    if (valueProp !== value) {
      setValue(valueProp ?? '')
    }
  }, [valueProp])

  return (
    <Input value={value} onChange={handleChange} {...props}>
      {children}
      {editable && value && (
        <Slot name="right">
          <div className="flex gap-3">
            <button
              type="button"
              className="cursor-pointer"
              aria-label="텍스트 삭제"
              onClick={handleResetButtonClick}
              tabIndex={-1}
            >
              <Icon
                name="delete"
                size="24"
                strokeWidth={1.5}
                className="text-gray-300"
              />
            </button>
          </div>
        </Slot>
      )}
    </Input>
  )
}
